import { AIBadge } from "@similarweb/ai-kit";

import { translate } from "app/filters/i18nFilter";

import { generateAutomationName } from "../../../helpers/generateAutomationName";

import { AI_SUGGESTED_BADGE } from "./texts";

export const SuggestedTopicPill = () => (
    <span data-automation={generateAutomationName("badge", ["suggested-topic"])}>
        <AIBadge
            gradientVariant="softer"
            text={translate(AI_SUGGESTED_BADGE)}
        />
    </span>
);
